import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-qr",
  "use": "foquz-icon-qr-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-qr\"><path d=\"M7 1v1M1 7H.99M12 7h1.01M9 7H7V5m0 5v-.01m3 .01h3m-3 3h.01M7 13h.01M13 13h.01M4 7h.01M1 4V1h3v3H1zm0 9v-3h3v3H1zm9-9V1h3v3h-3z\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol